import React from 'react';

import {
  FEATURE_GATES,
  PermissionFilter,
  GlobalFeatureGateFilter
} from '@ubisend/pulse-auth';
import {
  Panel,
  PageWrapper
} from '@ubisend/pulse-components';

import { Zendesk } from '../Components';

const ZendeskPage = () => (
  <PageWrapper beta="true" header="Zendesk" subheader="Configure your Zendesk">
    <GlobalFeatureGateFilter for={FEATURE_GATES.GENERATIVE_AI}>
      <GlobalFeatureGateFilter for={FEATURE_GATES.GENERATIVE_AI_ZENDESK}>
        <PermissionFilter can="view generative ai resource">
          <Panel>
            <Zendesk />
          </Panel>
        </PermissionFilter>
      </GlobalFeatureGateFilter>
    </GlobalFeatureGateFilter>
  </PageWrapper>
);

export default ZendeskPage;